import { HttpRequest, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { IClaimMessageUpdateResponse } from 'app/claims/components/messenger/interfaces/claim-message-update-response.interface';
import { IClaimMessengerConversation } from 'app/claims/components/messenger/interfaces/claim-messenger-conversation.interface';
import { IClaimMessengerMessage } from 'app/claims/components/messenger/interfaces/claim-messenger-message.interface';
import { ApiEndpointService } from 'app/core/services/api-endpoint.service';
import { makeEndpointMatcher } from 'app/mocks/utils/make-endpoint-matcher';
import { IMockRegistry } from 'app/mocks/interfaces/mock-registry.interface';

export function mockUpdateMessage(
    apiEndpointService: ApiEndpointService,
): IMockRegistry {
    const endpointKey = 'claims.conversations.updateMessage';
    const endpointMatcher = makeEndpointMatcher(endpointKey, apiEndpointService);

    return {
        method: 'PUT',
        ...endpointMatcher,
        handler: (
            req: HttpRequest<unknown>,
            params: Record<string, string>,
            current?: IClaimMessengerConversation,
            payload?: Partial<IClaimMessengerMessage>,
        ) => {
            if (!current) {
                throw new Error(`No existing conversation in cache for ${ req.url }`);
            }

            // 1) Locate and merge the message
            const updatedMessage: IClaimMessengerMessage = current.messages.map(m =>
                m.messageId === params.messageId
                    ? { ...m, ...payload }
                    : m,
            ).find(m => m.messageId === params.messageId)!;

            // 2) Mutate the in‑memory conversation so future GETs see the change
            current.messages = current.messages.map(m =>
                m.messageId === params.messageId ? updatedMessage : m,
            );

            // 3) (Optional) You could also recalc counts here:
            current.totalCount = current.messages.length;
            current.unreadAdjusterCount = current.messages.filter(m => !m.isMessageRead).length;

            // 4) Return the update‑response shape
            const body: IClaimMessageUpdateResponse = {
                claimId: current.claimId,
                message: updatedMessage,
            };

            return new HttpResponse({
                status: HttpStatusCode.Ok,
                body,
            });
        },
    };
}
